import MainLayout from "../components/CommonComponents/MainLayout";
import UnderConstructionIcon from "../components/CommonComponents/UnderConstructionIcon";

export default function CustomerAccessControlPage() {
  return (
    <MainLayout>
      <div className="px-4 pt-6 sm:px-6">
        <h1 className="text-3xl font-bold text-gray-900">Customer Access Control</h1>
        <p className="mt-2 text-sm text-gray-500">
          Manage customer access permissions and controls from this tab.
        </p>
        <div className="mt-8 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <UnderConstructionIcon size={84} className="min-h-[320px]" />
        </div>
      </div>
    </MainLayout>
  );
}
